<template>
  <div class="radio-group">
    <div
      v-for="(item, index) in items"
      class="v-centerer radio-wrapper clickable-hoverable"
      :class="{ disabled: disabled }"
      @click="disabled ? '' : emitInput(item[valueKey], value.desc)"
    >
      <Checkbox :value="radioVal === item[valueKey]" :title="item[labelKey]" round />
      <slot :name="index"></slot>
      <div class="radio-sort v-centerer" v-show="sortable && item[valueKey] == radioVal">
        <img
          :src="value.desc ? '/images/desc-bold.png' : '/images/desc.png'"
          alt=""
          @click.stop="emitInput(value.value, !value.desc)"
        />
        <img
          class="ascending"
          :src="value.desc ? '/images/desc.png' : '/images/desc-bold.png'"
          alt=""
          @click.stop="emitInput(value.value, !value.desc)"
        />
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Radio buttons to switch between values
 *
 * @vue-prop {Object|Number} value - If sortable option is false, v-model can be managed with an integer value
 *                           corresponding to items[x].valueKey
 *                           If sortable is true, v-model is an object as following: {value: items[x].valueKey, desc: Boolean}
 * @vue-prop {Array} items - Array of items to select [{ valueKey: X, labelKey: 'label' }]
 * @vue-prop {String=id} valueKey - key of the attribute to use as the value in items objects
 * @vue-prop {String=label} labelKey - key of the attribute to use as the label in items objects
 * @vue-prop {Boolean} sortable - if true, sorting arrows will be displayed next to the label
 *                     clicking those arrows will change the desc property of this.value
 * @vue-prop {Boolean} disabled - Whether this component should be disabled
 */

import Checkbox from '@/components/checkbox.vue';

export default {

  name: 'RadioGroup',

  components: {
    Checkbox,
  },

  props: {
    value: {
      type: [Object, Number],
    },
    items: {
      type: Array,
      default: () => [],
    },
    valueKey: {
      type: String,
      default: "id",
    },
    labelKey: {
      type: String,
      default: "label",
    },
    sortable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    val() {
      return this.value || (this.sortable ? { value: 0, desc: true } : 0);
    },
    radioVal: {
      get() {
        return this.sortable ? this.val.value : this.val;
      },
      set(newVal) {
        this.emitInput(newVal, !!this.val.desc);
      }
    }
  },

  methods: {
    emitInput(value, desc) {
      if (!this.disabled) {
        this.$emit('input', this.sortable ? { value, desc } : value);
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.radio-wrapper {
  position: relative;

  input[type=radio] {
    display: none;

    &:checked label {
      color: $color-main-text;
    }
    &:checked ~ .radio-custom > div {
      top: 2px;
      left: 2px;
      width: 8px;
      height: 8px;
    }
  }
  .radio-sort {
    padding-left: 15px;

    img {
      width: 15px;
      height: auto;
      cursor: pointer;

      &.ascending {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
